module.exports = __webpack_public_path__ + "img/D0005.04004c56.svg";